<template>
  <div class="marketDemand">
    <div class="table"
         v-for="(item,index) in demandList"
         :key='index'>
      <a-row class="matchdisplay-title">
        <a-col class="title">
          需求 | {{item.demandName}}
        </a-col>
      </a-row>
      <div class="matchdisplay-name">
        <TitleCard title="专利成果"
                   :type="'firstCard'"
                   :showMore="false">
        </TitleCard>
      </div>
      <a-row :gutter="16"
             v-for="(operationList, index) in item.operation"
             :key="index"
             :class="[index === operationList.length - 1 ? 'last' : '']">
        <a-col class="gutter-row"
               :span="8">
          <div class="gutter-box name"
               @click="detailClick(operationList.id)">
            {{ operationList.patent_name }}
          </div>
        </a-col>
        <a-col class="gutter-row"
               :span="8">
          <div class="gutter-box">专利权人: {{ operationList.operation_owner }}</div>
        </a-col>
        <a-col class="gutter-row"
               :span="8">
          <div class="gutter-box right">
            专利价值度:<span class="value">{{ operationList.operation_value }}</span>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { viewResultInfo } from '@/api/tradingInfos.js'

export default {
  data() {
    return {}
  },
  mounted() {},
  props: {
    demandList: Array,
  },
  methods: {
    async detailClick(id) {
      this.$router.push({ name: 'detailDeal', query: { id } })
      await viewResultInfo(id)
    },
  },
}
</script>
